import {clickOn } from "./click"
import {load} from "./load"
import { initTimer } from "./timer"
import { setProp, getProp } from "./properties"
import { whenClose, whenOpen } from "./popup"
import { onResize } from "./resize"
import { getPage } from "../page"

export { clickOn, load, initTimer, getPage, setProp, getProp, whenClose, whenOpen, onResize }